import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { APP_SETTINGS, ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { VideosService } from '../videos/videos.service';
import { TakataRecallService } from './takata-recall.service';
import { NgIf, NgClass, NgFor, NgStyle, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ShareContentComponent } from '../share-content/share-content.component';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';
import { BrandTypePipe } from '../../shared/pipes/brand-type.pipe';


@Component({
    selector: 'app-takata-recall',
    templateUrl: './takata-recall.component.html',
    styleUrls: ['./takata-recall.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        FormsModule,
        NgFor,
        RouterLink,
        ShareContentComponent,
        NgStyle,
        DatePipe,
        SearchFilterPipe,
        BrandTypePipe,
    ],
})
export class TakataRecallComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscription: ISubscription[];
  public isShowBulletins = true;
  public isShowVideos = false;
  public isShowDocs = false;
  public takataRecallDocs: any;
  public docType: string;
  public serviceError = 'Loading data. Please wait...';
  public shareContentObject = {};
  public search4bulletins;
  APP_SETTINGS: any;
  errorMessage = '';

  documentTypes = new Map();

  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  private username: string;

  constructor(
    private utilityService: UtilityService,
    private takataRecallService: TakataRecallService,
    private changeDetector: ChangeDetectorRef,
    private authService: AuthService,
    private videoService: VideosService,
    private spinnerService: SpinnerService,
    private toastService: ToastConfigService,
    private analyticsService: AnalyticsService,
    private router: Router,
    private userProfileService: UserProfileService
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.subscription = [];
    this.documentTypes.set('Onboard Diagnostic', 'mount/obd')
      .set('Technical Training Manual', 'mount/tech_training_manual')
      .set('Technical Documentation', 'mount/technical_documentation')
      .set('Body And Paint Manual', 'mount/body_and_paint_manual')
      .set('Operating Fluid', 'mount/operating_fluid')
      .set('Equipment Manual', 'mount/equipment_manual')
      .set('Onboard Diagnostic', 'mount/obd')
      .set('Tool Report', 'mount/tool')
      .set('PBS', 'mount/parts_bulletin');

    this.search4bulletins = (APP_SETTINGS.currentPage == 'takata') ? this.takataRecallService.getFilterData() : '';
    APP_SETTINGS.currentPage = 'takata';
    if (APP_SETTINGS.takataRecall == 'bulletins') { this.showBulletins(); }
    if (APP_SETTINGS.takataRecall == 'videos') { this.showVideos(); }
    if (APP_SETTINGS.takataRecall == 'documents') { this.showDocs(); }
    this.takataRecallDocs = [];
    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }
    }));
  }

  showBulletins() {
    this.isShowBulletins = true;
    this.isShowVideos = false;
    this.isShowDocs = false;
    this.errorMessage = '';
    APP_SETTINGS.takataRecall = 'bulletins';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.takataRecallService.getUserTakataRecallBulletins().subscribe(data => {
      this.docType = 'bulletins';
      this.takataRecallDocs = data;
      if (this.takataRecallDocs.length === 0) {
        this.errorMessage = 'No Takata Recall Bulletins Found';
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showVideos() {
    this.isShowBulletins = false;
    this.isShowVideos = true;
    this.isShowDocs = false;
    this.errorMessage = '';
    APP_SETTINGS.takataRecall = 'videos';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.takataRecallService.getTakataRecallVideos().subscribe(data => {
      this.docType = 'videos';
      this.takataRecallDocs = data;
      if (this.takataRecallDocs.length === 0) {
        this.errorMessage = 'No Takata Recall Videos Found';
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  showDocs() {
    this.isShowBulletins = false;
    this.isShowVideos = false;
    this.isShowDocs = true;
    this.errorMessage = '';
    APP_SETTINGS.takataRecall = 'documents';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.takataRecallService.getTakataRecallDocuments().subscribe(data => {
      this.docType = 'documents';
      this.takataRecallDocs = data;
      if (this.takataRecallDocs.length === 0) {
        this.errorMessage = 'No Takata Recall Documents Found';
      }
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  shareContent(id, type, channel, videoDisplayNumber) {
    this.shareContentObject = {
      id: id,
      type: type,
      channel: channel,
      videoDisplayNumber: videoDisplayNumber
    };
  }
  addVideoToWatchlist(videoId, videoDisplayNumber) {
    //Analytics call
    this.analyticsService.trackSavedContentByTypeLineMake('Takata Recall', videoDisplayNumber, 'saved');
    //Analytics call
    this.subscription.push(this.videoService.addVideoToWatchlist(this.username, videoId).subscribe(data => {
      if (data) {
        this.toastService.popToast('Video added to watchlist');
      }
    }));
  }
  navigateToBulletin(bulletin) {
    //Analytics Call
    //takataRecallCode
    this.saveToAnalytics(bulletin.bulletinDisplayNumber, bulletin.takataRecallCode);

    this.takataRecallService.saveFilterData(this.search4bulletins);
    this.router.navigate(['/bulletin', bulletin.bulletinDisplayId], { queryParams: { type: bulletin.bulletinType } });
    // this.changeDetector.detectChanges();
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

  saveToAnalytics(documentTitle, takataRecallCode) {
    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.tracDocumentsTakataRecallByUser('Takata Recall', documentTitle, takataRecallCode, this.username);
    }
    else {
      this.analyticsService.tracDocumentsTakataRecallByTypeLineMake('Takata Recall', documentTitle, takataRecallCode);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentTakataRecallType('Takata Recall', documentTitle, takataRecallCode, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('Takata Recall', documentTitle, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }
  }
}
